import { render, staticRenderFns } from "./VesselsDashboard.vue?vue&type=template&id=251423ea&"
import script from "./VesselsDashboard.vue?vue&type=script&lang=js&"
export * from "./VesselsDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports